import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const dialogWorkspacePickerUiEvents = eventGroup({
  source: 'Modeler Dialog Workspace Picker UI',
  events: {
    workspaceConfirmClicked: type<void>(),
    newWorkspaceClicked: type<void>(),
  },
});
